import { useMemo } from "react"
import Schema from "./Schema"

const LocalBusinessSchema = () => {
  const schema = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Majordomo (ООО «Хостинг»)',
    url: `https://${process.env.NEXT_PUBLIC_DOMAIN}`,
    logo: `https://${process.env.NEXT_PUBLIC_DOMAIN}/img/logo.svg`,
    image: `https://${process.env.NEXT_PUBLIC_DOMAIN}/img/logo.svg`,
    description: 'Хостинг для бизнеса, гос. организаций и частных пользователей. Покупка доменных имён, хостинг сайтов, VDS/VPS хостинг, аренда серверов, SSL сертификаты, лицензии 1С-Битрикс.',
    
    // Контакты
    telephone: '+7-800-777-55-25',
    email: 'info@majordomo.ru',
    
    // Адрес
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'а/я 34, ООО "Хостинг"',
      addressLocality: 'Санкт-Петербург',
      postalCode: '196233',
      addressCountry: 'RU',
    },
    
    // Географические координаты (Санкт-Петербург)
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 59.9342802,
      longitude: 30.3350986,
    },
    
    // Часы работы
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        opens: '00:00',
        closes: '23:59',
      },
    ],
    
    // Ценовой диапазон
    priceRange: '₽₽',
    
    // Социальные сети
    sameAs: [
      'https://t.me/majordomo_ru',
      'https://vk.com/majordomo_live',
      'https://zen.yandex.ru/id/61e95d9bcacc3718a6833a53',
      'https://www.youtube.com/channel/UCKUbH9NxgmjMVytBsVjr4xw'
    ],
    
    // Категория бизнеса
    '@id': `https://${process.env.NEXT_PUBLIC_DOMAIN}/#localbusiness`,
    
    // Дополнительная информация
    currenciesAccepted: 'RUB',
    paymentAccepted: 'Наличные, Безналичный расчёт, Банковская карта, Электронные деньги',
  }), [])

  return (
    <Schema schema={schema} />
  )
}

export default LocalBusinessSchema

